<div class="ag-theme-material grid-wrapper" data-cy="grid-engine-grid-page">
  <ag-grid-angular
    [masterDetail]="!!masterDetailEnabled()"
    [detailCellRenderer]="masterDetailCellRenderer()"
    [detailRowAutoHeight]="!!masterDetailRowAutoHeight()"
    (firstDataRendered)="onFirstDataRendered($event)"
    (gridReady)="onGridReady($event)"
    (newColumnsLoaded)="onGridColumnsChanged()"
    (sortChanged)="onSortChange()"
    [colResizeDefault]="'shift'"
    [columnDefs]="columnDefs()"
    [defaultColDef]="defaultColDef"
    [getLocaleText]="getLocaleText"
    [gridOptions]="gridOptions"
    [navigateToNextCell]="navigateToNextCell"
    [navigateToNextHeader]="navigateToNextHeader"
    [rowClassRules]="rowClassRules()"
    [rowData]="rowData()"
    [sideBar]="sideBar"
    [tabToNextCell]="tabToNextCell"
    [tabToNextHeader]="tabToNextHeader"
    style="flex: 2"
  />
  @if (!hidePaginator()) {
    <grid-engine-paginator
      [ngClass]="{ 'ag-max-count-reached': !!grid()?.data?.response?.pagination?.maxCountReached }"
      (pageChange)="onPageChange($event)"
      [pagination]="$safeNavigationMigration(grid()?.data?.response?.pagination)"
    />
  }
</div>
<ng-template #exportViewRef />
